// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgExit = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill={props.color ?? 'currentColor'} clipPath="url(#exit_svg__a)">
      <path d="M9 16H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V2H2v12h6v-1c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1" />
      <path d="M15.92 7.61c-.02-.06-.07-.1-.1-.15-.04-.05-.06-.12-.11-.16l-3-3a.996.996 0 1 0-1.41 1.41L12.59 7H6c-.55 0-1 .45-1 1s.45 1 1 1h6.59l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a1.006 1.006 0 0 0 .21-1.1z" />
    </g>
    <defs>
      <clipPath id="exit_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgExit
